module.exports = __webpack_public_path__ + "img/spit.5751314d.gif";